import { render, staticRenderFns } from "./dorm1.vue?vue&type=template&id=725b9a21&"
import script from "./dorm1.vue?vue&type=script&lang=js&"
export * from "./dorm1.vue?vue&type=script&lang=js&"
import style0 from "./dorm1.vue?vue&type=style&index=0&id=725b9a21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports